module.exports = __webpack_public_path__ + "static/wrow3-6b1e43380d41634467f2dfdcb999dc1d.jpg";